import React, { FC } from "react";

const SIZE_CLASSES = {
  xs: {
    fixed: "w-8 h-8",
    autoHeight: "w-8 h-auto",
    width: "32",
    height: "32",
  },
  sm: {
    fixed: "w-10 h-10",
    autoHeight: "w-10 h-auto",
    width: "40",
    height: "40",
  },
  md: {
    fixed: "w-12 h-12",
    autoHeight: "w-12 h-auto",
    width: "48",
    height: "48",
  },
  lg: {
    fixed: "w-20 h-20",
    autoHeight: "w-20 h-auto",
    width: "80",
    height: "80",
  },
  xl: {
    fixed: "w-32 h-32",
    autoHeight: "w-32 h-auto",
    width: "128",
    height: "128",
  },
};

type PropsType = {
  className?: string;
  src: string;
  size: keyof typeof SIZE_CLASSES;
  withRing?: boolean;
  autoHeight?: boolean;
};

export const Avatar: FC<PropsType> = ({
  className = "",
  src,
  size,
  withRing = false,
  autoHeight = false,
}: PropsType) => {
  const sizeClass = autoHeight
    ? SIZE_CLASSES[size].autoHeight
    : SIZE_CLASSES[size].fixed;

  return (
    <div className={`shrink-0 ${sizeClass}`}>
      <img
        src={src}
        width={SIZE_CLASSES[size].width}
        height={autoHeight ? undefined : SIZE_CLASSES[size].height}
        alt="avatar"
        className={`object-cover max-w-full w-full h-full rounded-full ${withRing ? "ring-2 ring-primary-800" : ""} ${className}`}
      />
    </div>
  );
};
